export default __webpack_public_path__ + "static/media/P306.0.c9fcc58a.mp3";